/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'

/**
 * The AutoActionTask model module.
 * @module model/AutoActionTask
 * @version 1.0.0
 */
export default class AutoActionTask {
  /**
   * Constructs a new <code>AutoActionTask</code>.
   * @alias module:model/AutoActionTask
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>AutoActionTask</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AutoActionTask} obj Optional instance to populate.
   * @return {module:model/AutoActionTask} The populated <code>AutoActionTask</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AutoActionTask()

      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Number')
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String')
      }
      if (data.hasOwnProperty('auto_action_config_id')) {
        obj['auto_action_config_id'] = ApiClient.convertToType(data['auto_action_config_id'], 'Number')
      }
      if (data.hasOwnProperty('title')) {
        obj['title'] = ApiClient.convertToType(data['title'], 'String')
      }
      if (data.hasOwnProperty('body')) {
        obj['body'] = ApiClient.convertToType(data['body'], 'String')
      }
      if (data.hasOwnProperty('action_status')) {
        obj['action_status'] = ApiClient.convertToType(data['action_status'], 'String')
      }
    }
    return obj
  }

  /**
   * @member {Number} id
   */
  id = undefined
  /**
   * @member {String} name
   */
  name = undefined
  /**
   * @member {Number} auto_action_config_id
   */
  auto_action_config_id = undefined
  /**
   * @member {String} title
   */
  title = undefined
  /**
   * @member {String} body
   */
  body = undefined
  /**
   * Enum(open, closed)
   * @member {String} action_status
   */
  action_status = undefined
}
